import { Text, type TextProps } from '@blueprintjs/core'
import React from 'react'
import { useScreenshotMode } from '../../hooks/useScreenshotMode'

interface NameTextProps extends TextProps {
    screenshotMode?: boolean
    children?: React.ReactNode
}

// Blueprint Text puts the full text in a hover title when it overflows; the blur does not cover a tooltip.
export const NameText = ({ screenshotMode, title, ...props }: NameTextProps) => {
    const hidden = useScreenshotMode(screenshotMode)
    return <Text ellipsize {...props} title={hidden ? '' : title} />
}
